module.exports = __webpack_public_path__ + "static/media/1POLICY35.31419792.jpg";